import { RouteRecordRaw } from 'vue-router';
import { env } from '@/env';

// Development-only routes that are only available in dev mode
export const devRoutes: RouteRecordRaw[] = [
  {
    path: '/dev',
    name: 'DevTools',
    component: () => import('@/pages/dev/index.vue'),
    meta: {
      requiresDevMode: true,
      title: 'Development Tools',
    },
    beforeEnter: (to, from, next) => {
      if (env().isDevMode) {
        next();
      } else {
        // Redirect to 404 or home in production
        next({ name: 'NotFound' });
      }
    },
  },
  {
    path: '/dev/xml-mapper-test',
    name: 'XmlMapperTest',
    component: () => import('@/pages/dev/xml-mapper-test/index.vue'),
    meta: {
      requiresDevMode: true,
      title: 'XML Mapper Test',
    },
    beforeEnter: (to, from, next) => {
      if (env().isDevMode) {
        next();
      } else {
        next({ name: 'NotFound' });
      }
    },
  },
  // Add more dev routes here
];

// Global route guard to protect all dev routes
export const devRouteGuard = (to: any, from: any, next: any) => {
  // Check if route requires dev mode
  const requiresDevMode = to.matched.some(
    (record: any) => record.meta.requiresDevMode
  );

  if (requiresDevMode && !env().isDevMode) {
    console.warn('Attempted to access dev route in production:', to.path);
    next({ name: 'NotFound' });
    return;
  }

  next();
};
